import IpawsAffectedAreaSection from '../IpawsAffectedAreaSection/IpawsAffectedAreaSection';
import IpawsAudioSection from '../IpawsAudioSection/IpawsAudioSection';
import IpawsEventClassificationSection from '../IpawsEventClassificationSection/IpawsEventClassificationSection';
import IpawsMessageHandlingSection from '../IpawsMessageHandlingSection/IpawsMessageHandlingSection';
import IpawsPublicMessageSection from '../IpawsPublicMessageSection/IpawsPublicMessageSection';
import IpawsTimingSection from '../IpawsTimingSection/IpawsTimingSection';

/**
 * Renders the shared IPAWS authoring fields with a combined audio allowance.
 * @param props - The draft, findings, authoring callbacks, and optional audio selections.
 * @returns The authoring sections.
 */
const IpawsAuthoringSections = ({
  draft,
  findings = [],
  contractOptions,
  environment,
  authorizedWeaHandlingOptions,
  isWeaHandlingLoading = false,
  isWeaHandlingError = false,
  channelRules,
  onDraftChange,
  onTextChange,
  onDateTimeChange,
  authorizedAreas,
  permittedArea,
  hasReviewedDraft = false,
  onReviewDraft,
  onClearJurisdiction,
  onSelectAuthorizedJurisdiction,
  audio,
  spanishAudio = { file: null, duration: 0 },
  onAudioChange,
  onSpanishAudioChange,
  renderArea = true,
  showIntervalDuration = false,
  statusHelp = null,
}) => (
  <>
    <IpawsMessageHandlingSection
      draft={draft}
      findings={findings}
      contractOptions={contractOptions}
      onDraftChange={onDraftChange}
      onTextChange={onTextChange}
      statusHelp={statusHelp}
    />
    <IpawsEventClassificationSection
      draft={draft}
      findings={findings}
      contractOptions={contractOptions}
      environment={environment}
      authorizedWeaHandlingOptions={authorizedWeaHandlingOptions}
      isWeaHandlingLoading={isWeaHandlingLoading}
      isWeaHandlingError={isWeaHandlingError}
      channelRules={channelRules}
      onDraftChange={onDraftChange}
      onTextChange={onTextChange}
    />
    <IpawsPublicMessageSection
      draft={draft}
      findings={findings}
      onDraftChange={onDraftChange}
      onTextChange={onTextChange}
    />
    {audio && draft.deliveryChannels?.includes('EAS') ? (
      <>
        <IpawsAudioSection
          file={audio.file}
          duration={audio.duration}
          otherAudioBytes={
            draft.languages?.some(({ language }) => language === 'es-US')
              ? (spanishAudio.file?.size ?? 0)
              : 0
          }
          label="English Audio (Optional)"
          onChange={onAudioChange}
        />
        {draft.languages?.some(({ language }) => language === 'es-US') ? (
          <IpawsAudioSection
            file={spanishAudio.file}
            duration={spanishAudio.duration}
            otherAudioBytes={audio.file?.size ?? 0}
            label="Spanish Audio (Optional)"
            onChange={onSpanishAudioChange}
          />
        ) : null}
      </>
    ) : null}
    <IpawsTimingSection
      draft={draft}
      findings={findings}
      onDraftChange={onDraftChange}
      onDateTimeChange={onDateTimeChange}
      expiryLimits={channelRules?.expiryLimits}
      showIntervalDuration={showIntervalDuration}
    />
    {renderArea ? (
      <IpawsAffectedAreaSection
        draft={draft}
        findings={findings}
        permittedArea={permittedArea}
        hasReviewedDraft={hasReviewedDraft}
        onTextChange={onTextChange}
        onReviewDraft={onReviewDraft}
        onClearJurisdiction={onClearJurisdiction}
        authorizedAreas={authorizedAreas}
        onSelectAuthorizedJurisdiction={onSelectAuthorizedJurisdiction}
      />
    ) : null}
  </>
);

export default IpawsAuthoringSections;
